import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import type { DispatchNote } from "../../api/dispatchOrders";
import { formatDate, formatMoneyCode } from "../../lib/format";

/**
 * The invoices that bill a dispatch note: number, date, amount to the para and what is open, or the state. A note no
 * invoice names says the link is not recorded in the ERP, never that it is unbilled.
 */
export function NoteInvoices({ note }: { note: DispatchNote }) {
  const { t, i18n } = useTranslation();
  const jezik = i18n.resolvedLanguage;
  if (note.invoices.length === 0) {
    return <span style={muted}>{t("orderErp.noInvoice", "no invoice link is recorded in the ERP")}</span>;
  }
  return (
    <>
      {note.invoices.map((r) => (
        <div key={r.id} style={row}>
          <span>{t("orderErp.invoice", "Invoice {{number}}", { number: r.number })}</span>
          <span style={muted}>{formatDate(r.issueDate)}</span>
          {r.grossAmount !== null && <span>{formatMoneyCode(r.grossAmount, r.currency, jezik, naPare)}</span>}
          {r.status === "OPEN" || r.status === "PARTIALLY_PAID" ? (
            <span style={muted}>
              {t("orderErp.invoiceOpen", "open {{amount}}", {
                amount: formatMoneyCode(r.openAmount, r.currency, jezik, naPare),
              })}
            </span>
          ) : (
            r.status && <span style={muted}>{t(`finance.status.${r.status}`, r.status)}</span>
          )}
        </div>
      ))}
    </>
  );
}

const row: CSSProperties = { display: "flex", flexWrap: "wrap", gap: "2px 10px", alignItems: "baseline", fontSize: 13 };
const muted: CSSProperties = { color: "var(--ink-3)", fontSize: 12 };
// An invoice to the para: the dinar's default drops the decimals, and a partly paid invoice read "open 0".
const naPare: Intl.NumberFormatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
